import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Lista de Precios Pro + Menú Irresistible',
    desc: 'Tu menú 3 niveles + textos para WA e Instagram + políticas listas',
    value: '$12.000'
  }, {
    num: '02',
    title: 'Kit WhatsApp que Cierra Turnos',
    desc: '55 scripts para convertir consultas en reservas y manejar objeciones',
    value: '$15.000'
  }, {
    num: '03',
    title: 'Checklist Home Studio 5 Estrellas',
    desc: 'Profesionalizá tu espacio sin gastar una fortuna',
    value: '$10.000'
  }, {
    num: '04',
    title: 'Tablero Agenda Llena',
    desc: 'Sistema de turnos, señas, cancelaciones y lista de espera',
    value: '$12.000'
  }, {
    num: '05',
    title: 'Pack Reseñas y Prueba Social',
    desc: '15 scripts para pedir reseñas y sistema de Google My Business',
    value: '$10.000'
  }, {
    num: '06',
    title: 'Clienta Ideal y Filtro Anti-Toxic',
    desc: '12 señales de alerta + 8 guiones de filtrado + políticas listas',
    value: '$10.000'
  }];
  return <section className="py-20 px-4 bg-brand/5 border-y border-brand/20" data-id="element-63">
      <div className="max-w-6xl mx-auto" data-id="element-64">
        <div className="text-center mb-16" data-id="element-65">
          <div className="inline-flex items-center space-x-2 bg-brand text-white px-6 py-2 rounded-full mb-6 font-bold shadow-[0_0_20px_rgba(244,63,122,0.4)]" data-id="element-66">
            <Gift className="w-5 h-5" data-id="element-67" />
            <span data-id="element-68">SIEMPRE INCLUIDOS</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-black" data-id="element-69">
            🎁 6 BONOS ESTRATÉGICOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-70">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-2xl p-6 relative overflow-hidden group hover:border-brand transition-colors" data-id="element-71">
              <div className="absolute -right-4 -top-4 text-8xl font-black text-white/5 group-hover:text-brand/5 transition-colors" data-id="element-72">
                {bonus.num}
              </div>
              <div className="relative z-10" data-id="element-73">
                <div className="text-brand font-bold mb-2" data-id="element-74">
                  Bono {bonus.num}
                </div>
                <h4 className="text-xl font-bold mb-3 text-white" data-id="element-75">
                  {bonus.title}
                </h4>
                <p className="text-gray-400 mb-6" data-id="element-76">{bonus.desc}</p>
                <div className="flex items-center justify-between mt-auto pt-4 border-t border-dark-border" data-id="element-77">
                  <span className="text-gray-500 line-through text-sm" data-id="element-78">
                    Valor {bonus.value}
                  </span>
                  <span className="text-brand font-black" data-id="element-79">GRATIS</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-brand/20 to-brand/5 border border-brand/30 rounded-2xl p-8 text-center max-w-3xl mx-auto" data-id="element-80">
          <div className="text-gray-300 mb-2" data-id="element-81">Valor total de los 6 bonos</div>
          <div className="flex items-center justify-center space-x-4" data-id="element-82">
            <span className="text-3xl text-gray-500 line-through font-bold" data-id="element-83">
              $69.000
            </span>
            <span className="text-4xl md:text-5xl font-black text-brand" data-id="element-84">
              → GRATIS
            </span>
          </div>
          <div className="text-sm text-gray-400 mt-2" data-id="element-85">
            ✅ Incluidos con tu Ultrapack
          </div>
        </motion.div>
      </div>
    </section>;
}